//
//
//
//
//
//
//

export default {

    props: {
        item: {
            required: true
        },
        readonly: {
            default: false
        }
    },

    data: function data() {
        return {
            loading: false,
            removing: false,
            initialized: false
        };
    },


    methods: {
        remove: function remove() {
            var _this = this;

            this.removing = true;
            new Form({ rowId: this.item.rowId }).post('/api/cart/remove').then(function (response) {
                App.event.fire('cart.updated', response);
                _this.removing = false;
            });
        }
    },

    computed: {
        removeIcon: function removeIcon() {
            return this.removing ? 'fa fa-spinner' : 'icon-remove';
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/cart-small/components/CartSmallRow.vue
// module id = 9ipY
// module chunks = 4